import React, { useEffect } from "react"
import { BasicTable } from "../../common/Table"
import { useTranslation } from "react-i18next"
import { Box, Typography } from "@material-ui/core"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { useDispatch, useSelector } from "react-redux"
import { setDashboardReview } from "../../../actions/dashboardActions"

const useStyles = makeStyles((theme) => ({
	userReviewOverviewTable: {
		maxHeight: "300px",
		"& .MuiTableCell-root": {
			borderBottom: `1px ${theme.typography.button.disabledColor} solid`,
		},
	},
	reviewName: {
		cursor: "pointer",
	},
	userReviewBox: {
		border: `1px ${theme.typography.button.disabledColor} solid`,
		borderRadius: 3,
		marginTop: 15,
	},
}))

function TabularView({ getUserReviewDetails }) {
	const [t] = useTranslation("global")
	const classes = useStyles()
	const dispatch = useDispatch()

	const selectedReview = useSelector((state) => state.dashboard?.selectedReview)
	const reviewOverview = useSelector((state) => state.info?.reviewOverviewDetails?.review_overview || [])
	const reviewList = useSelector((state) => state.review?.allReviewlist)
	const isUserReviewOverviewLoading = useSelector((state) => state?.info?.isUserReviewOverviewLoading)
	const userReviewOverView = useSelector((state) => state.info?.userReviewOverviewDetails?.review_overview || [])

	const getUserName = (params) => {
		return <Typography noWrap>{params?.row?.user_name}</Typography>
	}

	const getColumns = () => {
		return [
			{
				field: "user_name",
				headerName: t("dashboard.userOverviewOnReviewTable.userName"),
				sortable: false,
				flex: 1.5,
				renderCell: getUserName,
			},
			{
				field: "total",
				headerName: t("dashboard.userOverviewOnReviewTable.totalAssigned"),
				sortable: false,
				flex: 1,
			},
			{
				field: "reviewed",
				headerName: t("dashboard.userOverviewOnReviewTable.reviewed"),
				sortable: false,
				flex: 1,
			},
		]
	}

	const getRows = () => {
		return userReviewOverView?.length > 0 ? userReviewOverView : []
	}

	useEffect(() => {
		if (reviewList?.length > 0 && reviewOverview?.length > 0) {
			const firstReview = reviewOverview?.[0] || undefined
			if (!_.isEmpty(firstReview)) {
				const selectedReview = reviewList?.find((item) => item?.id === firstReview?.review_id)
				getUserReviewDetails(selectedReview?.id)
				dispatch(setDashboardReview(selectedReview))
			}
		}
	}, [reviewList, reviewOverview])

	return (
		<Box className={classes.userReviewBox}>
			<BasicTable
				columns={getColumns()}
				rows={getRows()}
				isLoading={isUserReviewOverviewLoading}
				pageInfo={{
					page: 1,
					pageSize: getRows()?.length,
					rowsPerPageOptions: [5, 10, 20, 50],
					totalRowCount: getRows()?.length,
					paginationMode: "server",
					handlePageChange: () => {},
					handlePageSizeChange: () => {},
				}}
				showPagination={false}
				sortInfo={{
					sortingMode: "server",
					sortModel: [],
					onSortModelChange: () => {},
				}}
				checkboxSelection={false}
				footerInfo={{
					hideFooter: false,
					hideSelectionCount: true,
					hidePagination: true,
				}}
				topBarInfo={{
					show: true,
					rightSection: "",
				}}
				totalCountText={`${t("dashboard.userOverviewOnReviewTable.totalUsers")} ${getRows()?.length}`}
				showDownloadButton={false}
				showColumnsButton={false}
				customClass={classes.userReviewOverviewTable}
				customCellPadding="16px"
			/>
		</Box>
	)
}

export default TabularView
